import { Injectable } from '@angular/core';
import { CanLoad, Route, UrlSegment, UrlTree } from '@angular/router';
import { environment } from 'projects/brn-frontend/src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class EnvironmentGuard implements CanLoad {
  constructor() {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return !environment.production;
  }
}
